import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

/**
 * Pendências do respondente no módulo de formulários: a lista de "Meus formulários"
 * (compartilhada pelo menu do topo, pelo banner do início e pela listagem), o número
 * a responder (badge do menu) e os bloqueantes (banner e tela de obrigatórios).
 *
 * `rotaRetorno` guarda onde o usuário estava quando a API recusou a navegação com
 * o 403 E205020, para voltar para lá depois que os obrigatórios forem enviados.
 */
export const useFormulariosStore = defineStore('formularios', () => {
    const listaVazia = () => ({ pendentes: [], em_andamento: [], respondidos: [] });

    const meusFormularios = ref(listaVazia());
    const totalPendentes = ref(0);
    const bloqueantes = ref([]);
    const rotaRetorno = ref(null);

    const temBloqueantes = computed(() => bloqueantes.value.length > 0);

    // Conta só o que dá para responder agora: agendados e expirados ficam de fora
    const definirMeusFormularios = (dados) => {
        meusFormularios.value = {
            pendentes: dados?.pendentes ?? [],
            em_andamento: dados?.em_andamento ?? [],
            respondidos: dados?.respondidos ?? [],
        };
        totalPendentes.value = [...meusFormularios.value.pendentes, ...meusFormularios.value.em_andamento]
            .filter((item) => item.pode_responder !== false).length;
    };

    const definirBloqueantes = (pendencias) => {
        bloqueantes.value = Array.isArray(pendencias) ? pendencias : [];
    };

    const definirRotaRetorno = (rota) => {
        rotaRetorno.value = rota;
    };

    const limpar = () => {
        meusFormularios.value = listaVazia();
        totalPendentes.value = 0;
        bloqueantes.value = [];
        rotaRetorno.value = null;
    };

    return {
        meusFormularios,
        totalPendentes,
        bloqueantes,
        rotaRetorno,
        temBloqueantes,
        definirMeusFormularios,
        definirBloqueantes,
        definirRotaRetorno,
        limpar,
    };
});
